module.exports = __webpack_public_path__ + "assets/icon-like-component.cc7b087f.svg";